var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.113,0L18.9,0C19.513,0 20,0.488 20,1.1L20,18.9C20,19.5 19.513,20 18.9,20L13.8,20L13.8,12.25L16.4,12.25L16.788,9.238L13.8,9.238L13.8,7.313C13.8,6.438 14.05,5.838 15.3,5.838L16.9,5.838L16.9,3.138C16.625,3.1 15.675,3.025 14.575,3.025C12.262,3.025 10.688,4.425 10.688,7.013L10.688,9.238L8.075,9.238L8.075,12.25L10.688,12.25L10.688,20L1.113,20C0.82,20 0.539,19.885 0.33,19.679C0.122,19.473 0.003,19.193 0,18.9L0,1.1C0,0.488 0.5,0 1.113,0Z","style":{"fill":"rgb(44,117,226)","fillRule":"nonzero"}}));
}

Facebook.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 20 20","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Facebook;

Facebook.default = Facebook;
